export default "__VITE_ASSET__d7654d40__"